<template>
  <v-container id="city-get" v-if="!isGov">
    <v-breadcrumbs
      v-if="isSala"
      :items="breadCrumbs"
      divider=">"
    ></v-breadcrumbs>

    <city-header :payload="payload" @realod="loadFirst"> </city-header>
    <!-- <v-row v-if="isSala">
  <v-col >
       <v-card class="perguntas-edicao-container" elevation="0">

          <div class="pe-header">
            <div class="pe-header__left">
              <div class="pe-header__badge">
                <v-icon small color="white">mdi-pencil-lock-outline</v-icon>
                Edição exclusiva na inscrição 2026
              </div>
              <h3 class="pe-header__title">Perguntas 17 e 18</h3>
              <p class="pe-header__subtitle">
                Atualização aberta até <strong>25/06/2026 às 18h</strong>
                (Brasília). Se os dados já estiverem corretos, não é necessário
                alterar.
              </p>
            </div>

         
            <div
              class="pe-timer"
              :class="
                prazoEdicaoPerguntasExpirado ? 'pe-timer--expired' : 'pe-timer--active'
              "
            >
              <v-icon
                :color="prazoEdicaoPerguntasExpirado ? '#ef4444' : '#2563eb'"
                size="18"
                class="pe-timer__icon"
              >{{ prazoEdicaoPerguntasExpirado ? 'mdi-lock-clock' : 'mdi-timer-outline' }}</v-icon>
              <div>
                <div class="pe-timer__label">Tempo restante</div>
                <div class="pe-timer__value">{{ countdownEdicaoPerguntas }}</div>
              </div>
            </div>
          </div>

          <v-card-text class="pe-body">

            <div class="pe-pergunta">
              <div class="pe-pergunta__numero">17</div>
              <div class="pe-pergunta__conteudo">
                <p class="pe-pergunta__texto">
                  Quantos profissionais atuam no atendimento da sala do
                  empreendedor/espaço parceiro?
                </p>
                <v-text-field
                  v-model="edicaoPerguntas.quantidadeProfissionais"
                  type="number"
                  min="0"
                  outlined
                  dense
                  placeholder="Ex.: 4"
                  :disabled="prazoEdicaoPerguntasExpirado || loadingEdicaoPerguntas"
                  hide-details="auto"
                />
              </div>
            </div>

            <div class="pe-pergunta">
              <div class="pe-pergunta__numero">18</div>
              <div class="pe-pergunta__conteudo">
                <p class="pe-pergunta__texto">
                  Relacione o nome dos profissionais que atuam no atendimento da
                  sala do empreendedor.
                </p>
                <v-textarea
                  v-model="edicaoPerguntas.nomesProfissionais"
                  outlined
                  dense
                  auto-grow
                  rows="3"
                  placeholder="Ex.: Ana Souza, Carlos Lima, Marina Alves"
                  :disabled="prazoEdicaoPerguntasExpirado || loadingEdicaoPerguntas"
                  hide-details="auto"
                />
              </div>
            </div>

            <div class="perguntas-edicao-acoes">
              <v-btn
                small
                outlined
                color="primary"
                :disabled="loadingEdicaoPerguntas"
                @click="cancelPerguntas17e18"
              >
                Cancelar
              </v-btn>
              <v-btn
                small
                color="primary"
                :loading="loadingEdicaoPerguntas"
                :disabled="
                  prazoEdicaoPerguntasExpirado || !hasPerguntasEdicaoChanges
                "
                @click="savePerguntas17e18"
              >
                Salvar
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
    </v-col>



</v-row> -->

    <div v-if="shouldShowDadosIanCards" class="dados-ian-bar">
      <v-row class="metric-row">
        <v-col
          v-for="card in dadosIanCards"
          :key="card.title"
          cols="12"
          sm="6"
          md="4"
          lg="4"
          xl="4"
          class="metric-col"
        >
          <v-tooltip bottom :disabled="!card.tooltip">
            <template #activator="{ on, attrs }">
              <div
                v-bind="attrs"
                class="metric-card"
                :class="getCardStatusClass(card)"
                @click="handleDadosIanCardClick(card)"
                v-on="on"
              >
                <div class="metric-card__background">
                  <div class="metric-card__icon-wrapper">
                    <v-icon :color="getIconColor(card)" size="28">
                      {{ card.icon }}
                    </v-icon>
                  </div>
                  <div class="metric-card__content">
                    <div class="metric-card__title">{{ card.title }}</div>
                    <div class="metric-card__value" :class="card.valueClass">
                      {{ card.display }}
                    </div>
                    <div
                      v-if="card.helper"
                      class="metric-card__helper"
                      :class="card.helperClass"
                    >
                      {{ card.helper }}
                    </div>
                  </div>
                </div>
                <div
                  class="metric-card__indicator"
                  :class="getIndicatorClass(card)"
                ></div>
              </div>
            </template>
            <span>{{ card.tooltip }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="ianMemoriaDialog" max-width="1280px">
      <v-card class="ian-memory-dialog">
        <v-card-title class="ian-memory-dialog__title">
          <div>
            <div class="ian-memory-dialog__heading">
              Memória de cálculo do IAN UF
            </div>
            <div v-if="ianMemoriaResumo" class="ian-memory-dialog__summary">
              UF {{ ianMemoriaResumo.uf }} · IAN UF
              {{ formatIanDisplay(ianMemoriaResumo.ianUf) }} ·
              {{ ianMemoriaResumo.totalMunicipiosConsideradosUf || 0 }} de
              {{ ianMemoriaResumo.totalMunicipiosElegiveisUf || 0 }}
              municípios elegíveis considerados · mínimo
              {{ ianMemoriaResumo.minimoMunicipiosAmostra || 0 }}
              ({{
                formatPercentDisplay(ianMemoriaResumo.faixaAmostralPercentual)
              }})
            </div>
          </div>
          <v-spacer />
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="!ianMemoriaRows.length"
                @click="exportIanMemoriaCalculo"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Baixar XLS</span>
          </v-tooltip>
          <v-btn icon @click="ianMemoriaDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="ianMemoriaHeaders"
            :items="ianMemoriaRows"
            :loading="ianMemoriaLoading"
            :items-per-page="50"
            dense
            fixed-header
            height="520"
            class="ian-memory-table"
          >
            <template #item.consideradoCalculoIan="{ item }">
              <v-chip
                small
                :color="item.consideradoCalculoIan === 'Sim' ? 'green' : 'grey'"
                text-color="white"
              >
                {{ item.consideradoCalculoIan || "Não" }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-col cols="3">
      <v-row>
        <v-col>
          <v-btn
            v-if="
              config.downloadDiagnostico && groupsConfig.downloadDiagnostico
            "
            color="laranja"
            class="ml-3"
            @click="downloadPdf"
            style="color: #fff"
          >
            PDF Inscrição
          </v-btn>
        </v-col>
      </v-row>
      <template
        v-if="
          isFullAdmin ||
          (config.naoVerClienteOcultoOuro &&
            groupsConfig.naoVerClienteOcultoOuro &&
            payload.seloFinal &&
            payload.seloFinal.length > 0 &&
            payload.seloFinal[0].selo != 'Ouro') ||
          (!config.naoVerClienteOcultoOuro &&
            !groupsConfig.naoVerClienteOcultoOuro) ||
          (config.naoVerClienteOcultoOuro &&
            !groupsConfig.naoVerClienteOcultoOuro) ||
          (!config.naoVerClienteOcultoOuro &&
            groupsConfig.naoVerClienteOcultoOuro)
        "
      >
        <v-row
          v-if="
            isFullAdmin ||
            (config.visualizaRelatorioFinal &&
              groupsConfig.visualizaRelatorioFinal)
          "
        >
          <v-col>
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              @click="verificarRelatorioFinal()"
            >
              Relatório Final
            </v-btn>
          </v-col>
        </v-row>
      </template>

      <v-row>
        <v-col>
          <v-btn
            outlined
            color="primary"
            class="ml-3"
            v-if="
              payload.diagnostico === false &&
              (isFullAdmin ||
                (config.realizarDiagnostico &&
                  groupsConfig.realizarDiagnostico))
            "
            @click="openDiagnostic()"
          >
            <template v-if="isSala">
              RESPONDER CRITÉRIOS <br />
              DE AVALIAÇÃO
            </template>
            <template v-else> RESPONDER DIAGNÓSTICO </template>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <app-modal-edit-city
            v-if="
              isFullAdmin ||
              (config.editarMunicipio && groupsConfig.editarMunicipio)
            "
            @save="loadCity()"
            :payload="payload"
            :edit="true"
          ></app-modal-edit-city>
        </v-col>
      </v-row>
      <v-row v-if="config.resumoMunicipio && groupsConfig.resumoMunicipio">
        <v-col>
          <v-btn
            outlined
            color="primary"
            class="ml-3"
            @click="$router.push(`/cidade/${municipioId}/resumo-municipio`)"
          >
            <template v-if="isSala">RESUMO DO PARCEIRO</template>
            <template v-else-if="isTur"> RESUMO DO MUNICÍPIO</template>
            <template v-else-if="isGov"> ATORES DO PROJETO</template>

            <template v-else> ATORES DO MUNICÍPIO</template>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-if="
          config.relatorioMensal &&
          groupsConfig.relatorioMensal &&
          !isIndicadores &&
          !isSala
        "
      >
        <v-col>
          <app-modal-report :municipioId="municipioId"> </app-modal-report>
        </v-col>
      </v-row>
      <v-row
        v-if="
          config.dadosCadastraisMunicipio &&
          groupsConfig.dadosCadastraisMunicipio &&
          !isIndicadores &&
          !isSala
        "
      >
        <v-col>
          <modal-dados-cadastrais
            :dadosPayload="dadosCadastrais"
            @onLoad="loadDadosCadastrais"
          >
            <template v-slot:title> Dados Cadastrais </template>
          </modal-dados-cadastrais>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-btn
            outlined
            color="primary"
            class="ml-3"
            @click="
              $router.push(`/cidade/${municipioId}/agenteTerritorial/ator`)
            "
            v-if="
              isAT &&
              (isFullAdmin ||
                (config.agenteTerritorial && groupsConfig.agenteTerritorial))
            "
          >
            AGENTE TERRITORIAL
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="payload.linkMaps">
        <v-col>
          <v-btn outlined color="primary" class="ml-3" @click="openMaps()">
            ABRIR MAPS
          </v-btn>
        </v-col>
      </v-row>
      <v-card
        v-if="
          perfis.filter((item) => item.children && item.children.length)
            .length > 0 ||
          payload.prefeito ||
          payload.partido
        "
      >
        <v-card-text>
          <v-row>
            <v-col v-if="payload.prefeito">
              <h4>Prefeito</h4>
              <v-divider></v-divider>
              <span>{{ payload.prefeito }}</span>
            </v-col>
            <v-col v-if="payload.partido" lg="4" md="4" sm="4">
              <h4>Partido</h4>
              <v-divider></v-divider>
              <span>{{ payload.partido }}</span>
            </v-col>
          </v-row>

          <v-row
            v-if="
              perfis.filter((item) => item.children && item.children.length)
                .length > 0
            "
          >
            <v-col
              v-for="perfil in perfis"
              :key="perfil.idMunicipioResumoPerfil"
              lg="12"
              md="12"
              sm="12"
            >
              <h4>{{ perfil.nome }}</h4>

              <div v-for="children in perfil.children" :key="children.resumoId">
                <div>{{ children.nome }}</div>

                <div>{{ children.telefone }}</div>

                <div>{{ children.email }}</div>
              </div>
              <div v-if="!perfil.children.length">Não possui</div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-row class="aqui">
      <v-col
        v-if="
          isSala &&
          config.verDashboardEvidencia &&
          groupsConfig.verDashboardEvidencia
        "
        class="diagnosticoSelo"
        :cols="
          isFullAdmin ||
          (config.visualizaRelatorioFinal &&
            groupsConfig.visualizaRelatorioFinal) ||
          (config.realizarDiagnostico && groupsConfig.realizarDiagnostico) ||
          (config.editarMunicipio && groupsConfig.editarMunicipio) ||
          (config.relatorioMensal && groupsConfig.relatorioMensal) ||
          (config.verEvolucaoMunicipio && groupsConfig.verEvolucaoMunicipio)
            ? '9'
            : '12'
        "
      >
        <v-col
          v-if="
            config.verDashboardEvidencia && groupsConfig.verDashboardEvidencia
          "
        >
          <h3 class="mb-5 mt-5">Situação dos critérios</h3>

          <mini-dash :municipioId="parseInt(this.$route.params.id)"></mini-dash>
        </v-col>
      </v-col>
      <v-col
        md="9"
        sm="9"
        lg="9"
        v-if="
          !isSala ||
          (isSala &&
            !config.verDashboardEvidencia &&
            !groupsConfig.verDashboardEvidencia)
        "
      >
        <v-card>
          <v-card-text v-if="!isAT">
            <template
              v-if="
                (config.visualizarPontosMedalha &&
                  groupsConfig.visualizarPontosMedalha &&
                  getMunicipioVigente()) ||
                (config.verEvolucaoMunicipio &&
                  groupsConfig.verEvolucaoMunicipio) ||
                shouldShowConsolidado()
              "
            >
              <h4>{{ isSala ? "EVOLUÇÃO" : "EVOLUÇÃO DO MUNICÍPIO" }}</h4>
              <v-divider> </v-divider>
            </template>

            <div v-if="shouldShowConsolidado()" class="consolidado-bar">
              <v-row class="metric-row">
                <v-col
                  v-for="card in consolidadoCards"
                  :key="card.title"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="4"
                  xl="4"
                  class="metric-col"
                >
                  <div class="metric-card" :class="getCardStatusClass(card)">
                    <div class="metric-card__background">
                      <div class="metric-card__icon-wrapper">
                        <v-icon :color="getIconColor(card)" size="28">
                          {{ card.icon }}
                        </v-icon>
                      </div>
                      <div class="metric-card__content">
                        <div class="metric-card__title">{{ card.title }}</div>
                        <div
                          class="metric-card__value"
                          :class="card.valueClass"
                        >
                          {{ card.display }}
                        </div>
                        <div
                          v-if="card.helper"
                          class="metric-card__helper"
                          :class="card.helperClass"
                        >
                          {{ card.helper }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="metric-card__indicator"
                      :class="getIndicatorClass(card)"
                    ></div>
                  </div>
                </v-col>
              </v-row>
              <div class="consolidado-updated">
                Última atualização do IAN: {{ ianAtualizadoEmDisplay }}
              </div>
            </div>

            <v-row
              class="chart-row"
              v-if="
                (config.visualizarPontosMedalha &&
                  groupsConfig.visualizarPontosMedalha &&
                  getMunicipioVigente()) ||
                (config.verEvolucaoMunicipio &&
                  groupsConfig.verEvolucaoMunicipio)
              "
            >
              <v-col>
                <div
                  class="bar-chart-wrapper"
                  :class="{ 'has-many-items': shouldUseScroll }"
                  v-if="nomesTemas && nomesTemas.length > 0"
                >
                  <div class="custom-bar-chart" ref="customChart">
                    <div
                      v-for="(item, index) in nomesTemas"
                      :key="index"
                      class="bar-item"
                    >
                      <div class="bar-label">{{ item }}</div>
                      <div class="bar-group">
                        <div class="bar-container bar-container-total">
                          <div
                            class="bar-fill bar-fill-total"
                            :style="{
                              width: (percentuaisTemas[index] || 0) + '%',
                            }"
                            :title="`${
                              percentuaisTemas[index] || 0
                            }% alcançado`"
                          ></div>
                          <span class="bar-value"
                            >{{ percentuaisTemas[index] || 0 }}%</span
                          >
                        </div>
                        <div class="bar-container bar-container-validated">
                          <div
                            class="bar-fill bar-fill-validated"
                            :style="{
                              width:
                                (percentuaisTemasValidados[index] || 0) + '%',
                            }"
                            :title="`${
                              percentuaisTemasValidados[index] || 0
                            }% validado`"
                          ></div>
                          <span class="bar-value"
                            >{{ percentuaisTemasValidados[index] || 0 }}%</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="no-data">
                  <p>Nenhum dado disponível para exibição do gráfico.</p>
                  <p>
                    <strong>Debug:</strong> nomesTemas.length =
                    {{ nomesTemas?.length || 0 }}
                  </p>
                </div>
              </v-col>
            </v-row>
            <v-row
              align="center"
              justify="center"
              v-if="
                config.visualizarPontosMedalha &&
                groupsConfig.visualizarPontosMedalha &&
                getMunicipioVigente()
              "
            >
              <v-col
                v-for="medalha in payload.medalhas"
                v-bind:key="medalha.municipioMedalhaId"
                cols="2"
              >
                <div
                  v-if="
                    medalha.medalha.imagemBronzeBlob ||
                    medalha.medalha.imagemBronze
                  "
                >
                  <img
                    :src="
                      medalha.medalha.imagemBronzeBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemBronzeBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemBronze
                    "
                    v-if="medalha.possui === false && showMedalGrey === true"
                    :width="medalWidth"
                    class="grayScale"
                  />

                  <img
                    :src="
                      medalha.medalha.imagemOuroBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemOuroBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemOuro
                    "
                    v-if="medalha.possuiOuro"
                    :width="medalWidth"
                  />

                  <img
                    :src="
                      medalha.medalha.imagemPrataBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemPrataBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemPrata
                    "
                    v-if="!medalha.possuiOuro && medalha.possuiPrata"
                    :width="medalWidth"
                  />

                  <img
                    :src="
                      medalha.medalha.imagemBronzeBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemBronzeBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemBronze
                    "
                    v-if="!medalha.possuiPrata && medalha.possuiBronze"
                    v-bind:class="{ medalhas: !medalha.possui }"
                    :width="medalWidth"
                  />
                </div>
              </v-col>
            </v-row>

            <!-- <div v-if="estado === 'RJ1'">
              <h4>RELATÓRIO DO GESTOR</h4>
              <v-divider> </v-divider>

              <v-textarea
                v-model="payload.relatorioGestor"
                :disabled="!editReport"
                :readonly="!editReport"
              >
              </v-textarea>
              <v-divider> </v-divider>

              <v-col class="text-right">
                <v-btn
                  outlined
                  color="primary"
                  class="ml-3"
                  v-if="editReport === true"
                  @click="updateReport()"
                >
                  SALVAR
                </v-btn>

                <v-btn
                  v-if="
                    isAdmin ||
                    isConsultorCondutorMunicipio ||
                    isADMunicipio ||
                    isConsultorEspecialistaMunicipio
                  "
                  outlined
                  color="primary"
                  class="ml-3"
                  @click="editReport = !editReport"
                >
                  <span v-if="editReport === false"> EDITAR </span>
                  <span v-if="editReport === true"> CANCELAR </span>
                </v-btn>
              </v-col>
            </div> -->
          </v-card-text>
          <v-card-text v-if="isAT">
            <h4>SOBRE O MUNICÍPIO</h4>
            <v-divider> </v-divider>

            <v-row class="mt-4" style="min-height: 30vh">
              <v-col>
                {{ payload.descricao }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-row v-if="payload.prefeito">
              <v-col md="12" sm="12" lg="12">
                <h4 v-if="isSala">SOBRE O PARCEIRO</h4>
                <h4 v-if="isGov">SOBRE O PROJETO</h4>

                <h4 v-else>SOBRE O MUNICÍPIO</h4>
                <v-divider></v-divider>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.populacao">
                <h4>População</h4>
                <v-divider></v-divider>
                <span>{{ payload.populacao }} Hab.</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.orcamento">
                <h4>Orçamento</h4>
                <v-divider></v-divider>
                <span>R$ {{ payload.orcamento }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.isdel">
                <h4>ISDEL</h4>
                <v-divider></v-divider>
                <span>{{ payload.isdel }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.idh">
                <h4>IDH</h4>
                <v-divider></v-divider>
                <span>{{ payload.idh }}</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.pib">
                <h4>PIB</h4>
                <v-divider></v-divider>
                <span>{{ payload.pib }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.densidadeDemografica">
                <h4>Densidade Demográfica</h4>
                <v-divider></v-divider>
                <span>{{ payload.densidadeDemografica }} Hab/Km²</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.rendaMedia">
                <h4>Renda Média</h4>
                <v-divider></v-divider>
                <span>R$ {{ payload.rendaMedia }}</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.receita">
                <h4>Receita</h4>
                <v-divider></v-divider>
                <span>R$ {{ payload.receita }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.area">
                <h4>Área KM²</h4>
                <v-divider></v-divider>
                <span>{{ payload.area }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.despesa">
                <h4>Despesa</h4>
                <v-divider></v-divider>
                <span>R$ {{ payload.despesa }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.tempoMedio">
                <h4>Tempo Médio Abertura de Empresas</h4>
                <v-divider></v-divider>
                <span>{{ payload.tempoMedio }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.numeroEmpresas">
                <h4>Empresas</h4>
                <v-divider></v-divider>
                <span>{{ payload.numeroEmpresas }}</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.me">
                <h4>ME e EPP</h4>
                <v-divider></v-divider>
                <span>{{ payload.me }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.mei">
                <h4>MEI</h4>
                <v-divider></v-divider>
                <span>{{ payload.mei }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.totalMEI">
                <h4>MEI / Total</h4>
                <v-divider></v-divider>
                <span>{{ payload.totalMEI }} %</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.ideb">
                <h4>IDEB</h4>
                <v-divider></v-divider>
                <span>{{ payload.ideb }}</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.docentesEF">
                <h4>Nº Docentes Educação Infantil</h4>
                <v-divider></v-divider>
                <span>{{ payload.docentesEF }}</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.alunosEF">
                <h4>Nº Alunos Educação Infantil</h4>
                <v-divider></v-divider>
                <span>{{ payload.alunosEF }}</span>
              </v-col>
            </v-row>

            <v-row>
              <v-col md="4" sm="4" lg="4" v-if="payload.igm">
                <h4>IGM</h4>
                <v-divider></v-divider>
                <span>{{ payload.igm }} %</span>
              </v-col>
            </v-row>

            <v-row v-if="payload.atividades && payload.atividades.length > 0">
              <v-col md="12" sm="12" lg="12">
                <h3>Atividades Econômicas</h3>
                <v-divider></v-divider>
                <v-row
                  v-for="atividade in payload.atividades"
                  v-bind:key="atividade.municipioAtividadeId"
                  align="center"
                >
                  <v-col md="3" sm="3" lg="3">
                    <v-avatar color="primary">
                      <v-icon color="white">
                        {{ atividade.atividade.icone }}
                      </v-icon>
                    </v-avatar>
                  </v-col>

                  <v-col>
                    {{ atividade.atividade.nome }}
                  </v-col>
                  <v-col> Participação: {{ atividade.percentual }} % </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <modal-link-oculto-relatorio-final
        :municipio="payload"
        :dialog="abrirModalRelFinal"
        @relFimCriado="gerarRelatorioFinal()"
        @atualizarRelatorio="loadCity()"
      ></modal-link-oculto-relatorio-final>
    </v-row>
  </v-container>
  <Gov v-else></Gov>
</template>

<script>
import moment from "moment-timezone";
import "moment/locale/pt-br";
import AppModalEditCity from "./ModalEdit";
import CityHeader from "./Header";
import { cityAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppModalReport from "@/modules/report/components/ModalReport";
import ModalDadosCadastrais from "@/modules/city/components/propostas/modalDadosCadastrais.vue";
import AgenteTerritorial from "@/modules/agenteTerritorial/list";
import {
  resumoMunicipioApi,
  resumoMunicipioPerfilApi,
  municipioPropostaDadosApi,
} from "@/apis";
import {
  statusRelacionamentoEnum,
  statusRelacionamentoSeloEnum,
  statusContratoEnum,
} from "@/types";
import { diagnosticAPI } from "@/modules/diagnostic/components/DiagnosticAPI.js";
import { reportAPI } from "@/modules/report/API/ReportAPI";
import ModalLinkOcultoRelatorioFinal from "./ModalLinkOcultoRelatorioFinal.vue";
import Swal from "sweetalert2";
import { seloDiagnosticoRespostaAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoRespostaAPI";
import { seloDiagnosticoPerguntasAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoPerguntasAPI";
import MiniDash from "./MiniDash.vue";
import Gov from "./infoMunicipio/gov.vue";
import { municipioTemasHabilitadosAPI } from "@/apis";
import { atualUfDefinition, EnumAmbienteTipos } from "@/helpers/utils";
import { administrativeDashboardAPI } from "@/modules/administrative-dashboard/API/AdministrativeDashboardAPI";

export default {
  components: {
    AppModalEditCity,
    CityHeader,
    AppModalReport,
    ModalDadosCadastrais,
    AgenteTerritorial,
    ModalLinkOcultoRelatorioFinal,
    MiniDash,
    Gov,
  },
  data() {
    return {
      removeLoading: false,
      // Dados dos canais digitais
      canaisDigitais: {
        primeiroEndereco: "",
        segundoEndereco: "",
      },
      canaisDigitaisOriginais: {
        primeiroEndereco: "",
        segundoEndereco: "",
      },
      loadingCanaisDigitais: false,
      loadingEdicaoPerguntas: false,
      edicaoPerguntas: {
        quantidadeProfissionais: "",
        nomesProfissionais: "",
      },
      edicaoPerguntasOriginais: {
        quantidadeProfissionais: "",
        nomesProfissionais: "",
      },
      // Timer para verificação do banner
      bannerTimer: null,
      atualizacaoBanner: 0, // Força reatividade
      acompanhamento: {
        nome: "Diagnóstico",
        municipioId: parseInt(this.$route.params.id),
        usuarioId: 1,
      },
      breadCrumbs: [
        {
          text: "Selecionar a Sala",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Evidências",
          disabled: true,
          to: `/cidade/${this.$route.params.id}`,
          exact: true,
        },
      ],
      abrirModalRelFinal: false,
      municipioId: this.$route.params.id,
      medalWidth: "135px",
      config: JSON.parse(localStorage.getItem("config")),
      userTeste: JSON.parse(localStorage.getItem("user")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      showMedalGrey: false,
      payload: {
        acompanhamentos: [],
        temas: [],
      },
      dadosCadastrais: {},
      statusRelacionamentoEnum: statusRelacionamentoEnum,
      statusRelacionamentoSeloEnum: statusRelacionamentoSeloEnum,
      statusContratoEnum: statusContratoEnum,
      editReport: false,
      nomesAcompanhamentos: [],
      pontosAcompanhamentos: [],
      nomesTemas: [],
      percentuaisTemas: [],
      percentuaisTemasValidados: [],
      lineChart: {},
      temasHabilitados: [],
      lineChartOptions: {
        // onHover: (e) => {
        //   if (e.type == 'mousemove') {
        //     this.lineChartOptions.scales.xAxes[0].ticks.display = true
        //   } else if (e.type == 'mouseout') {
        //     this.lineChartOptions.scales.xAxes[0].ticks.display = false
        //   }
        // },

        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
                max: 100,
                display: false,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },

        responsive: true,
        maintainAspectRatio: false,
      },
      barChart: {},
      barChartOptions: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 15,
            bottom: 15,
          },
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: true,
                color: "#f1f5f9",
                lineWidth: 1,
                drawBorder: false,
              },
              ticks: {
                autoSkip: false,
                fontSize: 14,
                fontFamily: "Inter, sans-serif",
                fontColor: "#475569",
                padding: 12,
                maxRotation: 0,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
                max: 100,
                fontSize: 14,
                fontFamily: "Inter, sans-serif",
                fontColor: "#64748b",
                callback: function (value) {
                  return value + "%";
                },
              },
              gridLines: {
                display: true,
                color: "#f8fafc",
                lineWidth: 1,
                drawBorder: false,
              },
              scaleLabel: {
                display: true,
                labelString: "Percentual de Conclusão (%)",
                fontSize: 14,
                fontFamily: "Inter, sans-serif",
                fontColor: "#475569",
                fontStyle: "bold",
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          mode: "single",
          backgroundColor: "rgba(15, 23, 42, 0.95)",
          titleFontFamily: "Inter, sans-serif",
          bodyFontFamily: "Inter, sans-serif",
          titleFontSize: 13,
          bodyFontSize: 12,
          titleFontColor: "#f1f5f9",
          bodyFontColor: "#cbd5e1",
          cornerRadius: 8,
          displayColors: true,
          borderColor: "#334155",
          borderWidth: 1,
          xPadding: 12,
          yPadding: 12,
          callbacks: {
            title: function (tooltipItem, data) {
              const index = tooltipItem[0].index;
              return data.labels[index].replace(/\n/g, " ");
            },
            label: function (tooltipItem, data) {
              const value = tooltipItem.xLabel;
              const percentage = Math.round(value);
              let status = "";

              if (percentage >= 80) {
                status = "🟢 Excelente";
              } else if (percentage >= 60) {
                status = "🟡 Bom";
              } else if (percentage >= 40) {
                status = "🟠 Regular";
              } else {
                status = "🔴 Precisa Melhorar";
              }

              return [`Progresso: ${percentage}%`, `Status: ${status}`];
            },
            afterLabel: function (tooltipItem, data) {
              const value = tooltipItem.xLabel;
              if (value === 100) {
                return "✅ Meta atingida!";
              } else {
                const remaining = 100 - value;
                return `Faltam: ${Math.round(remaining)}% para meta`;
              }
            },
          },
        },
        animation: {
          duration: 1200,
          easing: "easeOutCubic",
          animateRotate: true,
          animateScale: true,
        },
        hover: {
          mode: "single",
          animationDuration: 200,
        },
        responsive: true,
        maintainAspectRatio: false,
        devicePixelRatio: 1,
        onResize: function (chart, size) {
          chart.canvas.style.width = "100%";
          chart.canvas.width = chart.canvas.parentNode.clientWidth;
        },
        elements: {
          rectangle: {
            borderWidth: 0,
          },
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
        layout: {
          padding: 0,
        },
      },
      perfis: [],
      estado: this.$store.state.uf,
      situacaoMunicipio: null,
      ianMemoriaDialog: false,
      ianMemoriaLoading: false,
      ianMemoriaRows: [],
      ianMemoriaHeaders: [
        { text: "Ordem", value: "ordemCalculoIan", align: "start" },
        { text: "Município", value: "municipio", align: "start" },
        { text: "Código IBGE", value: "codigoIbge", align: "start" },
        { text: "Regional", value: "unidadeRegional", align: "start" },
        { text: "Elegível IAN", value: "elegivelIan", align: "start" },
        {
          text: "Considerado para Cálculo do IAN",
          value: "consideradoCalculoIan",
          align: "start",
        },
        {
          text: "Temas mensurados",
          value: "temasMensuradosIan",
          align: "start",
        },
        {
          text: "Situação da mensuração",
          value: "situacaoMensuracaoIan",
          align: "start",
        },
        { text: "IAN Município", value: "ianMunicipio", align: "start" },
        { text: "Motivo", value: "motivoCalculoIan", align: "start" },
      ],
    };
  },
  watch: {
    loading(val) {
      if (this.removeLoadingFirst) this.setLoading(val);
      else this.setLoading(true);
    },
  },
  methods: {
    ...mapActions(["setLoading", "setCityName", "setCityId"]),
    getPayloadField(keys) {
      return keys.reduce((acc, key) => {
        if (acc !== undefined && acc !== null && acc !== "") return acc;
        return this.payload ? this.payload[key] : undefined;
      }, undefined);
    },
    getPayloadNumber(keys, allowNull = false) {
      const value = this.getPayloadField(keys);
      return this.toChartNumber(value, allowNull);
    },
    getPayloadInt(keys) {
      const value = this.getPayloadField(keys);
      if (value === undefined || value === null || value === "") {
        return null;
      }
      const parsed = Number(value);
      return Number.isNaN(parsed) ? null : parsed;
    },
    formatPointsDisplay(value) {
      if (value === null || value === undefined) return "-";

      const numberValue = Number(value);
      if (Number.isNaN(numberValue)) return value;

      return numberValue.toLocaleString("pt-BR", {
        maximumFractionDigits: 2,
      });
    },
    formatIanDisplay(value) {
      if (value === null || value === undefined || value === "") return "-";

      const numberValue = Number(value);
      if (Number.isNaN(numberValue)) return value;

      return numberValue.toFixed(2);
    },
    formatIanMetaDisplay(value, meta) {
      const formattedValue = this.formatIanDisplay(value);
      const formattedMeta = this.formatIanDisplay(meta);

      if (formattedValue === "-" && formattedMeta === "-") return "-";

      return `${formattedValue} / ${formattedMeta}`;
    },
    formatPercentDisplay(value) {
      if (value === null || value === undefined || value === "") return "-";
      const parsed = Number(value);
      if (Number.isNaN(parsed)) return value;
      return `${parsed.toLocaleString("pt-BR", {
        maximumFractionDigits: 2,
      })}%`;
    },
    formatCountDisplay(value, emptyValue = "-") {
      if (value === null || value === undefined) return emptyValue;
      const parsed = Number(value);
      if (Number.isNaN(parsed)) return emptyValue;
      return parsed.toString();
    },
    formatIanAtualizadoEm(value) {
      if (!value) return "Sem atualização";
      const parsed = moment(value);
      if (!parsed.isValid()) return "Sem atualização";
      return parsed.format("DD/MM/YYYY HH:mm");
    },
    metaComparison(value, meta) {
      if (meta === null || meta === undefined) {
        return { helper: null, helperClass: "", valueClass: "" };
      }

      const comparableValue = value === null ? 0 : value;
      const isAbove = Number(comparableValue) >= Number(meta);
      const helper = `Meta: ${this.formatIanDisplay(meta)}`;

      return {
        helper,
        helperClass: isAbove ? "meta-above" : "meta-below",
        valueClass: isAbove ? "meta-above" : "meta-below",
      };
    },
    formatElegivel(value) {
      if (value === null || value === undefined || value === "") return "-";
      const normalized = value.toString().toLowerCase();
      if (normalized === "sim") return "Sim";
      if (normalized === "nao" || normalized === "não") return "Não";
      return value;
    },
    elegivelClass(value) {
      if (value === "Sim") return "meta-above";
      if (value === "Não") return "meta-below";
      return "";
    },
    wrapLabel(label) {
      // Manter o texto original sem truncar
      return label || "";
    },
    toChartNumber(value, allowNull = false) {
      if (value === undefined || value === null || value === "") {
        return allowNull ? null : 0;
      }

      if (
        typeof value === "string" &&
        value.toLowerCase().includes("sem mensura")
      ) {
        return 0;
      }

      const normalized =
        typeof value === "string" ? value.replace(",", ".") : value;
      const parsed = Number(normalized);

      if (Number.isNaN(parsed)) {
        return allowNull ? null : 0;
      }

      return parsed;
    },
    canShowDadosIanCard(key) {
      return Boolean(this.config?.[key] && this.groupsConfig?.[key]);
    },
    getTemaNota(temaId) {
      const temaInfo = this.payload.temas.find(
        (item) => item.tema.temaId === temaId
      );

      const percentualTema = this.toChartNumber(
        temaInfo ? temaInfo.percentualAtingido : null,
        true
      );

      if (percentualTema !== null) {
        return percentualTema;
      }

      const key = `${temaId}um`;
      const value = this.getPayloadField([
        key,
        key.toLowerCase(),
        key.toUpperCase(),
        `Um${temaId}`,
        `um${temaId}`,
      ]);

      if (value === undefined || value === null || value === "") {
        return this.getTemaPercentualFallback(temaId);
      }

      if (
        typeof value === "string" &&
        value.toLowerCase().includes("sem mensura")
      ) {
        return 0;
      }

      return value;
    },
    getTemaPercentualFallback(temaId) {
      const tema = this.payload.temas.find(
        (item) => item.tema.temaId === temaId
      );

      if (!tema || !tema.tema || !tema.tema.pontos) return 0;

      return Math.ceil((tema.pontos / tema.tema.pontos) * 100);
    },
    saveCanaisDigitais() {
      if (this.agoraSaoPaulo.isAfter(this.dataLimiteCanaisDigitais)) {
        this.$notification.error(
          `O prazo para alterações dos links encerrou em 21 de agosto de 2025 às 12h (horário de Brasília). Agora são ${this.agoraSaoPaulo.format(
            "DD/MM/YYYY HH:mm"
          )} (horário de Brasília).`
        );
        return;
      }

      this.loadingCanaisDigitais = true;

      const payload = [
        {
          resposta: this.canaisDigitais.primeiroEndereco,
          MunicipioId: this.municipioId,
          PerguntaId: 19,
          uf: this.uf,
          parceiro: this.isParceiro,
          ambiente: atualUfDefinition.ambient,
        },
        {
          resposta: this.canaisDigitais.segundoEndereco,
          MunicipioId: this.municipioId,
          PerguntaId: 20,
          uf: this.uf,
          parceiro: this.isParceiro,
          ambiente: atualUfDefinition.ambient,
        },
      ];

      seloDiagnosticoRespostaAPI
        .updateRespostaPergunta19e20(payload)
        .then((resp) => {
          this.canaisDigitaisOriginais = { ...this.canaisDigitais };
          this.$notification.success("Atualização realizada com sucesso!");
        })
        .catch((error) => {
          console.error("Erro ao salvar canais digitais:", error);
          this.$notification.error("Erro ao salvar");
        })
        .finally(() => {
          this.loadingCanaisDigitais = false;
        });
    },
    cancelEdit() {
      // Restaurar valores originais
      this.canaisDigitais = { ...this.canaisDigitaisOriginais };
    },
    savePerguntas17e18() {
      if (this.prazoEdicaoPerguntasExpirado) {
        this.$notification.error(
          `O prazo para alterações encerrou em 25/06/2026 às 18h (horário de Brasília). Agora são ${this.agoraSaoPaulo.format(
            "DD/MM/YYYY HH:mm:ss"
          )}.`
        );
        return;
      }

      const quantidade =
        this.edicaoPerguntas.quantidadeProfissionais === null ||
        this.edicaoPerguntas.quantidadeProfissionais === undefined
          ? ""
          : String(this.edicaoPerguntas.quantidadeProfissionais).trim();

      if (quantidade && !/^\d+$/.test(quantidade)) {
        this.$notification.error(
          "A pergunta 17 deve conter apenas números inteiros."
        );
        return;
      }

      const nomes =
        this.edicaoPerguntas.nomesProfissionais === null ||
        this.edicaoPerguntas.nomesProfissionais === undefined
          ? ""
          : String(this.edicaoPerguntas.nomesProfissionais);

      this.loadingEdicaoPerguntas = true;

      const payload = [
        {
          resposta: quantidade,
          MunicipioId: this.municipioId,
          PerguntaId: 26,
          uf: this.uf,
          parceiro: this.isParceiro,
          ambiente: `prod`,
        },
        {
          resposta: nomes,
          MunicipioId: this.municipioId,
          PerguntaId: 27,
          uf: this.uf,
          parceiro: this.isParceiro,
          ambiente: `prod`,
        },
      ];

      seloDiagnosticoRespostaAPI
        .updateRespostaPergunta26e27(payload)
        .then(() => {
          this.edicaoPerguntasOriginais = { ...this.edicaoPerguntas };
          this.$notification.success("Respostas atualizadas com sucesso!");
        })
        .catch((error) => {
          console.error("Erro ao salvar perguntas 26 e 27:", error);
          this.$notification.error("Erro ao salvar respostas");
        })
        .finally(() => {
          this.loadingEdicaoPerguntas = false;
        });
    },
    cancelPerguntas17e18() {
      this.edicaoPerguntas = { ...this.edicaoPerguntasOriginais };
    },
    loadPerguntas26e27() {
      Promise.all([
        seloDiagnosticoRespostaAPI.getRespostaPergunta(26, this.municipioId),
        seloDiagnosticoRespostaAPI.getRespostaPergunta(27, this.municipioId),
      ])
        .then(([resp26, resp27]) => {
          const resposta26 =
            resp26.data && resp26.data.length && resp26.data[0].resposta
              ? resp26.data[0].resposta
              : "";
          const resposta27 =
            resp27.data && resp27.data.length && resp27.data[0].resposta
              ? resp27.data[0].resposta
              : "";

          this.edicaoPerguntas = {
            quantidadeProfissionais: String(resposta26 || ""),
            nomesProfissionais: String(resposta27 || ""),
          };

          this.edicaoPerguntasOriginais = { ...this.edicaoPerguntas };
        })
        .catch((error) => {
          console.error("Erro ao carregar perguntas 26 e 27:", error);
          this.$notification.error("Erro ao carregar respostas das perguntas");
        });
    },
    startBannerTimer() {
      this.stopBannerTimer();
      this.bannerTimer = setInterval(() => {
        this.atualizacaoBanner += 1;
      }, 1000);
    },
    stopBannerTimer() {
      if (this.bannerTimer) {
        clearInterval(this.bannerTimer);
        this.bannerTimer = null;
      }
    },
    openExampleVideo() {
      // Abrir vídeo de exemplo em nova aba
      window.open(
        "https://slide1-images.s3.us-east-1.amazonaws.com/public/salvandoLinkGoogleEmpresa.mp4",
        "_blank"
      );
    },
    openDiagnosticoSelo() {
      if (this.situacaoMunicipio == "Diagnóstico Não iniciado") {
        this.modalDiagnosticoSelo();
      } else {
        this.$router.push("/cidade/" + this.municipioId + "/diagnostic/selo");
      }
    },
    modalDiagnosticoSelo() {
      Swal.fire({
        title:
          "O Sebrae agradece desde já a sua participação no Selo Sebrae de Referência em Atendimento!",
        html: `
        <div class='estruturas'>
<p style="font-size:20px; margin-bottom:1rem">O preenchimento do formulário de levantamento de informações é uma etapa obrigatória e tem por objetivos:
</p>
<p><strong>•</strong> Conhecer as estruturas atuais e serviços ofertados pelas instituições parceiras;</p>
<p><strong>•</strong> Acompanhar a evolução desses espaços antes e após a aplicação da metodologia do Selo Sebrae de Referência em Atendimento;</p>
<p><strong>•</strong> Receber informações sobre as instituições parceiras para avaliação de critérios descritos no Regulamento.</p>
</div>
<p  style="font-size:18px; margin:1rem 0">A aplicação do questionário do diagnóstico é realizada no formato “autopreenchimento”, ou seja, os responsáveis pelas instituições parceiras participantes receberão o formulário de forma digital (por meio do e-mail informado no formulário de inscrição) e deverão respondê-lo dentro do cronograma oficial do Selo (divulgado no site oficial do Selo).</p>
<div class='estruturas'>
<p style="font-size:20px; margin-bottom:1rem">As perguntas serão relacionadas aos seguintes aspectos:</p>
<p><strong>•</strong> Serviços ofertados;</p>
<p><strong>•</strong> Infraestrutura (física e digital); </p>
<p><strong>•</strong> Canais de Atendimento; </p>
<p><strong>•</strong> Equipes de atendimento; </p>
<p><strong>•</strong> Parceiros.</p>
</div>
<div class='atencao'>
<p style="font-size:30px; font-weight:bold">Leia com atenção!</p>
<p style="font-size:20px; margin:1.5rem 0">O formulário deverá ser preenchido até dia <strong>26/04/2024</strong> até as <strong>23:59h</strong>.</p>
</div>
<p style="font-size:20px; margin-bottom:1rem">O responsável pelo preenchimento do diagnóstico deverá:</p>
<div class='estruturas'>
<p><strong>•</strong> Preencher corretamente as informações solicitadas;</p>
<p><strong>•</strong> Responder a todas as perguntas com atenção e dentro do prazo estipulado pelo Sebrae;</p>
<p><strong>•</strong> Preencher somente <strong>UM formulário</strong>. Não deverão ser preenchidos mais de um formulário de diagnóstico por ${
          this.isParceiro ? "parceiro" : "sala"
        }.</p>
<p><strong>•</strong> Reserve um tempo destinado somente ao preenchimento do diagnóstico.</p>
<p><strong>•</strong> No Bloco de perguntas do diagnóstico nomeado como informações para o Cliente Oculto serão coletadas
  informações sobre ${
    this.isParceiro ? "os parceiros" : "as salas"
  } que serão utilizadas para realização do Cliente Oculto.</p>

<p><strong>•</strong> É necessário a leitura dos critérios relacionados ao Cliente Oculta que conta Critério de Avaliação  - Pilar Qualidade no atendimento remoto 8.1.1.2 CLIENTE OCULTO - ATENDIMENTO REMOTO</p>
<p><strong>•</strong> O preenchimento deverá ser realizado corretamente, pois não haverá substituição de informações após o encerramento do prazo para preenchimento do diagnóstico.</p>

<p style='text-align:center'> <a target="_blank" href="https://sebrae.com.br/Sebrae/Portal%20Sebrae/Selo%20de%20Refer%C3%AAncia/Regulamento%20Selo%20-%20Salas%20do%20Empreendedor%20-%202024_VF2.pdf">Leia o regulamento do selo sebrae de referência em atendimento </a></p>

</div>
        `,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "voltar",
        confirmButtonText: "ESTOU CIENTE E DE ACORDO",
        reverseButtons: true,
        width: "90%",
        customClass: {
          htmlContainer: "htmlContainer",
          popup: "tamanho",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push("/cidade/" + this.municipioId + "/diagnostic/selo");
        }
      });
    },
    verificarRelatorioFinal() {
      this.gerarRelatorioFinal();
      // if (
      //   this.isFullAdmin ||
      //   (this.config.podeTrocarLinkRelFim &&
      //     this.groupsConfig.podeTrocarLinkRelFim)
      // ) {
      //   this.abrirModalRelFinal = true;
      // } else {
      //   this.gerarRelatorioFinal();
      // }
    },
    getMunicipioVigente() {
      return true;
    },
    downloadPdf() {
      this.setLoading(true);
      const payload = {
        uf: this.uf,
        parceiro: this.isParceiro,
        municipioId: this.municipioId,
        banco: "selo-inscricao-2026",
      };
      seloDiagnosticoRespostaAPI
        .downloadPdf(payload)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Diagnostico - ${this.payload.nome} - ${
            this.payload.uf
          } - ${moment().format("DD_MM_YYYY_HH_mm")}.pdf`;
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter PDF de inscrição");
        });
    },

    shouldShowConsolidado() {
      console.log("Verificando exibição do consolidado...");
      console.log("Config:", this.config);
      console.log("GroupsConfig:", this.groupsConfig);
      if (
        !this.config.visualizarConsolidado ||
        !this.groupsConfig.visualizarConsolidado
      ) {
        return false;
      }

      if (
        this.config.visualizarConsolidadoSomenteElegivel &&
        this.groupsConfig.visualizarConsolidadoSomenteElegivel
      ) {
        const elegivel = this.formatElegivel(
          this.getPayloadField([
            "elegivelIan",
            "ElegivelIan",
            "elegivel_ian",
            "Elegível IAN",
          ])
        );
        return elegivel === "Sim";
      }

      return true;
    },
    getCardStatusClass(card) {
      if (card.title === "Elegível IAN") {
        const elegivel = card.display;
        if (elegivel === "Sim") return "metric-card--success";
        if (elegivel === "Não") return "metric-card--error";
      }

      if (card.valueClass === "meta-above") return "metric-card--success";
      if (card.valueClass === "meta-below") return "metric-card--error";
      if (card.valueClass === "metric-highlight") return "metric-card--primary";

      return "metric-card--default";
    },
    getIconColor(card) {
      const cardClass = this.getCardStatusClass(card);
      switch (cardClass) {
        case "metric-card--success":
          return "#10b981";
        case "metric-card--error":
          return "#ef4444";
        case "metric-card--primary":
          return "#3b82f6";
        default:
          return "#6b7280";
      }
    },
    getIndicatorClass(card) {
      const cardClass = this.getCardStatusClass(card);
      return cardClass.replace("metric-card--", "indicator--");
    },
    handleDadosIanCardClick(card) {
      if (!card || card.action !== "ianMemoriaCalculo") return;
      this.openIanMemoriaCalculo();
    },
    openIanMemoriaCalculo() {
      this.ianMemoriaDialog = true;
      this.ianMemoriaLoading = true;

      administrativeDashboardAPI
        .getIanMemoriaCalculo(this.municipioId)
        .then(({ data }) => {
          this.ianMemoriaRows = data || [];
        })
        .catch((error) => {
          console.error("Erro ao carregar memória de cálculo do IAN:", error);
          this.ianMemoriaRows = [];
          this.$notification.error(
            "Erro ao carregar memória de cálculo do IAN"
          );
        })
        .finally(() => {
          this.ianMemoriaLoading = false;
        });
    },
    escapeExcelCell(value) {
      if (value === null || value === undefined) return "";
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },
    exportIanMemoriaCalculo() {
      if (!this.ianMemoriaRows.length) return;

      const headerHtml = this.ianMemoriaHeaders
        .map((header) => `<th>${this.escapeExcelCell(header.text)}</th>`)
        .join("");
      const rowsHtml = this.ianMemoriaRows
        .map(
          (row) =>
            `<tr>${this.ianMemoriaHeaders
              .map(
                (header) =>
                  `<td>${this.escapeExcelCell(row[header.value])}</td>`
              )
              .join("")}</tr>`
        )
        .join("");

      const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"></head><body><table><thead><tr>${headerHtml}</tr></thead><tbody>${rowsHtml}</tbody></table></body></html>`;
      const blob = new Blob([html], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      const link = document.createElement("a");
      const resumo = this.ianMemoriaResumo || {};
      link.href = window.URL.createObjectURL(blob);
      link.download = `memoria-calculo-ian-${
        resumo.uf || this.uf || "uf"
      }-${moment().format("YYYYMMDD-HHmm")}.xls`;
      link.click();
      window.URL.revokeObjectURL(link.href);
    },
    eixosHabilitados() {
      municipioTemasHabilitadosAPI
        .listByMunicipio(this.$route.params.id)
        .then((resp) => {
          var temasPermissoes = this.payload.temas;

          temasPermissoes = temasPermissoes.filter((item) => {
            if (resp.data && resp.data.length > 0) {
              return resp.data.some((tema) => tema.temaId === item.tema.temaId);
            }
            return true;
          });

          this.payload.medalhas = this.payload.medalhas.filter((item) => {
            if (resp.data && resp.data.length > 0) {
              return resp.data.some(
                (tema) => tema.temaId === item.medalha.temaId
              );
            }
            return true;
          });

          if (!this.userTeste.grupo.verTodosEixos) {
            temasPermissoes = temasPermissoes.filter((item) =>
              this.userTeste.permissoes.some(
                (per) =>
                  per.eixoId === item.tema.eixoId &&
                  per.municipioId === item.municipioId
              )
            );

            this.payload.medalhas = this.payload.medalhas.filter((item) =>
              this.userTeste.permissoes.some(
                (per) =>
                  per.eixoId === item.medalha.temaId &&
                  per.municipioId === item.municipioId
              )
            );
          }

          temasPermissoes = temasPermissoes
            .map((item) => ({
              ...item,
              nota: this.getTemaNota(item.tema.temaId),
            }))
            .sort((a, b) =>
              a.tema.nome.localeCompare(b.tema.nome, "pt-BR", {
                sensitivity: "base",
              })
            );

          this.nomesTemas = temasPermissoes.map((item) =>
            this.wrapLabel(item.tema.nome)
          );

          this.percentuaisTemas = temasPermissoes.map((item) =>
            this.toChartNumber(item.nota)
          );

          this.percentuaisTemasValidados = temasPermissoes.map((item) =>
            this.toChartNumber(item.percentualValidado)
          );

          this.fillLineChart();
          this.fillBarChart();
          this.setLoading(false);
          this.removeLoadingFirst = true;
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter eixos habilitados");
        });
      return this.payload.temas.filter((item) => item.tema.habilitado);
    },
    loadCity() {
      this.abrirModalRelFinal = false;
      this.setLoading(true);

      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.setLoading(true);

          this.payload = resp.data;
          this.loadDadosCadastrais();
          this.setCityName(this.payload.nome);
          this.setCityId(this.payload.municipioId);
          this.$forceUpdate();

          this.nomesAcompanhamentos = this.payload.acompanhamentos.map(
            function (item) {
              return item.nome;
            }
          );

          this.pontosAcompanhamentos = this.payload.acompanhamentos.map(
            function (item) {
              return item.pontos;
            }
          );

          for (
            let count = 0;
            count < this.pontosAcompanhamentos.length;
            count++
          ) {
            if (count > 0)
              this.pontosAcompanhamentos[count] =
                this.pontosAcompanhamentos[count] +
                this.pontosAcompanhamentos[count - 1];
          }

          this.eixosHabilitados();
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    loadDadosCadastrais() {
      municipioPropostaDadosApi
        .getDadosPorMunicipioId(this.municipioId)
        .then((resp) => {
          this.dadosCadastrais =
            (resp.data && resp.data.length && resp.data[0]) || {};
        })
        .catch(() => {
          this.$notification.error("Erro ao obter os Dados cadastrais");
        });
    },
    async getResumoMunicipioPerfil() {
      try {
        const { data: resumiMunicipioPerfil } =
          await resumoMunicipioPerfilApi.list();
        this.perfis = resumiMunicipioPerfil;
      } catch (error) {
        this.$notification.error("Erro ao listar perfis do municipio");
      }
    },
    gerarRelatorioFinal() {
      this.abrirModalRelFinal = false;
      this.setLoading(true);
      reportAPI
        .downloadRelatorioFinal(this.municipioId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Relatorio Final - ${this.payload.nome}.pdf`;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatorio final");
        });
    },
    updateReport() {
      this.setLoading(true);
      cityAPI
        .update(this.payload)
        .then((resp) => {
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar relatório");
        });
    },
    openDiagnostic() {
      this.setLoading(true);
      diagnosticAPI
        .createDiagnostic(this.acompanhamento)
        .then((resp) => {
          this.setLoading(false);
          this.$router.push(
            "/diagnostico/" + this.acompanhamento.municipioId + "/tema"
          );
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao criar diagnóstico");
        });
    },
    fillLineChart() {
      this.lineChart = {
        labels: this.nomesAcompanhamentos,
        datasets: [
          {
            backgroundColor: "#5C8AB9",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: this.pontosAcompanhamentos,
          },
        ],
      };
    },
    fillBarChart() {
      // Os dados já estão em nomesTemas e percentuaisTemas
      console.log("=== DEBUG GRAFICO ===");
      console.log("nomesTemas:", this.nomesTemas);
      console.log("percentuaisTemas:", this.percentuaisTemas);
      console.log("payload.temas:", this.payload?.temas);
      console.log(
        "config.visualizarPontosMedalha:",
        this.config?.visualizarPontosMedalha
      );
      console.log(
        "groupsConfig.visualizarPontosMedalha:",
        this.groupsConfig?.visualizarPontosMedalha
      );
      console.log(
        "config.verEvolucaoMunicipio:",
        this.config?.verEvolucaoMunicipio
      );
      console.log(
        "groupsConfig.verEvolucaoMunicipio:",
        this.groupsConfig?.verEvolucaoMunicipio
      );
      console.log("getMunicipioVigente():", this.getMunicipioVigente());
      console.log("=== FIM DEBUG ===");
    },
    openMaps() {
      window.open(this.payload.linkMaps, "_blank");
    },
    loadFirst() {
      this.setLoading(true);
      if (this.isSala) {
        seloDiagnosticoPerguntasAPI
          .getSituacaoDiagnostico(this.$route.params.id)
          .then(({ data: situacao }) => {
            this.situacaoMunicipio = situacao[0].situacao;

            this.loadCity();
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao obter o status do municipio");
          });
      } else {
        this.loadCity();
      }
      if (this.$store.state.uf === "SC") {
        this.medalWidth = "135px";
      }

      if (this.$store.state.uf !== "SC") {
        this.showMedalGrey = true;
      }

      document.getElementsByClassName("v-main__wrap")[0].style.background =
        "none";
    },
    async loadResumoMunicipio() {
      try {
        const { data: resumoMunicipio } = await resumoMunicipioApi.list(
          this.municipioId
        );
        this.perfis = this.perfis.map((val) => ({
          ...val,
          children: resumoMunicipio.filter(
            (item) =>
              item.idMunicipioResumoPerfil == val.idMunicipioResumoPerfil
          ),
        }));
      } catch (error) {
        this.$notification.error("Erro ao listar perfis");
      }
    },
  },
  beforeMount() {
    if (this.isParceiro) {
      this.breadCrumbs = [
        {
          text: "Selecionar o Parceiro",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Evidências",
          disabled: true,
          to: `/cidade/${this.$route.params.id}`,
          exact: true,
        },
      ];
    }
  },
  mounted() {
    this.loadFirst();
    this.getResumoMunicipioPerfil();
    this.loadResumoMunicipio();
    this.loadPerguntas26e27();
    this.startBannerTimer();
  },
  beforeDestroy() {
    this.stopBannerTimer();
  },
  computed: {
    ...mapGetters([
      "loading",
      "isIndicadores",
      "isSala",
      "isFullAdmin",
      "isAT",
      "user",
      "isTur",
      "isParceiro",
      "isGov",
      "uf",
      "ambient",
    ]),
    barChartHeight() {
      // Altura mais compacta e proporcional
      return Math.max(400, this.nomesTemas.length * 60);
    },
    shouldUseScroll() {
      // Scroll quando há mais de 12 itens (gráfico com altura otimizada)
      return this.nomesTemas.length > 12;
    },
    dataLimiteEdicaoPerguntas() {
      return moment.tz(
        "2026-06-25 18:00:00",
        "YYYY-MM-DD HH:mm:ss",
        "America/Sao_Paulo"
      );
    },
    agoraSaoPaulo() {
      this.atualizacaoBanner;
      return moment().tz("America/Sao_Paulo");
    },
    prazoEdicaoPerguntasExpirado() {
      return this.agoraSaoPaulo.isAfter(this.dataLimiteEdicaoPerguntas);
    },
    countdownEdicaoPerguntas() {
      if (this.prazoEdicaoPerguntasExpirado) {
        return "Prazo encerrado em 30/06/2026 às 18h (horário de Brasília).";
      }

      const diff = this.dataLimiteEdicaoPerguntas.diff(this.agoraSaoPaulo);
      const duration = moment.duration(diff);
      const dias = Math.floor(duration.asDays());
      const horas = duration.hours();
      const minutos = duration.minutes();
      const segundos = duration.seconds();

      return `Tempo restante: ${dias}d ${horas}h ${minutos}m ${segundos}s`;
    },
    hasPerguntasEdicaoChanges() {
      return (
        String(this.edicaoPerguntas.quantidadeProfissionais || "") !==
          String(this.edicaoPerguntasOriginais.quantidadeProfissionais || "") ||
        String(this.edicaoPerguntas.nomesProfissionais || "") !==
          String(this.edicaoPerguntasOriginais.nomesProfissionais || "")
      );
    },
    chartStatistics() {
      if (!this.percentuaisTemas || this.percentuaisTemas.length === 0) {
        return null;
      }

      const values = this.percentuaisTemas.filter(
        (v) => v !== null && v !== undefined
      );
      if (values.length === 0) return null;

      const total = values.length;
      const sum = values.reduce((acc, val) => acc + val, 0);
      const average = Math.round(sum / total);

      // Contar por faixas de desempenho
      const excellent = values.filter((v) => v >= 80).length;
      const good = values.filter((v) => v >= 60 && v < 80).length;
      const regular = values.filter((v) => v >= 40 && v < 60).length;
      const needsImprovement = values.filter((v) => v < 40).length;

      // Melhor e pior desempenho
      const highest = Math.max(...values);
      const lowest = Math.min(...values);

      return {
        total,
        average,
        highest,
        lowest,
        distribution: {
          excellent,
          good,
          regular,
          needsImprovement,
        },
      };
    },
    dadosIanCards() {
      const metaUf = this.getPayloadNumber(
        ["meta_uf", "metaUF", "MetaUF"],
        true
      );
      const ianMunicipio = this.getPayloadNumber(
        ["ian_municipio", "IAN_Municipio", "ianMunicipio"],
        true
      );
      const ianRegional = this.getPayloadNumber(
        ["ian_regional", "IAN_Regional", "ianRegional"],
        true
      );
      const ianUf = this.getPayloadNumber(["ian_uf", "IAN_UF", "ianUF"], true);
      const status =
        this.getPayloadField([
          "status_consolidado",
          "statusMunicipio",
          "status_nome",
          "status",
        ]) || "-";
      const elegivel = this.formatElegivel(
        this.getPayloadField([
          "elegivelIan",
          "ElegivelIan",
          "elegivel_ian",
          "Elegível IAN",
        ])
      );
      const eixosUnicosCiclo = this.formatCountDisplay(
        this.getPayloadInt([
          "eixosunicosciclo",
          "EixosUnicosCiclo",
          "eixosUnicosCiclo",
        ])
      );
      const eixosUnicosCicloLista = this.getPayloadField([
        "eixosunicosciclolista",
        "EixosUnicosCicloLista",
        "eixosUnicosCicloLista",
      ]);
      const adsAtivosQtd = this.getPayloadInt([
        "ads_ativos_qtd",
        "adsAtivosQtd",
        "AdsAtivosQtd",
      ]);
      const adsAtivosNomes = this.getPayloadField([
        "ads_ativos_nomes",
        "adsAtivosNomes",
        "AdsAtivosNomes",
      ]);
      const salasEmpreendedorQtd = this.getPayloadInt([
        "salas_empreendedor_qtd",
        "salasEmpreendedorQtd",
        "SalasEmpreendedorQtd",
      ]);
      const salasEmpreendedorDetalhes = this.getPayloadField([
        "salas_empreendedor_detalhes",
        "salasEmpreendedorDetalhes",
        "SalasEmpreendedorDetalhes",
      ]);
      const territorioEmpreendedorNome = this.getPayloadField([
        "territorio_empreendedor_nome",
        "territorioEmpreendedorNome",
        "TerritorioEmpreendedorNome",
      ]);
      const territorioEmpreendedorNomes = this.getPayloadField([
        "territorio_empreendedor_nomes",
        "territorioEmpreendedorNomes",
        "TerritorioEmpreendedorNomes",
      ]);
      const iniciativasTerritorioQtd = this.getPayloadInt([
        "territorio_iniciativas_qtd",
        "territorioIniciativasQtd",
        "TerritorioIniciativasQtd",
        "qtdIniciativasTerritorio",
        "QtdIniciativasTerritorio",
      ]);
      const iniciativasTerritorioDetalhes = this.getPayloadField([
        "territorio_iniciativas_detalhes",
        "territorioIniciativasDetalhes",
        "TerritorioIniciativasDetalhes",
      ]);
      const mensuracaoPendenteRaw = this.getPayloadField([
        "mensuracao_pendente",
        "mensuracaoPendente",
        "MensuracaoPendente",
      ]);
      const mensuracaoPendente =
        mensuracaoPendenteRaw === true ||
        mensuracaoPendenteRaw === "true" ||
        mensuracaoPendenteRaw === 1;
      const mensuracaoPendenteTemas = this.getPayloadField([
        "mensuracao_pendente_temas",
        "mensuracaoPendenteTemas",
        "MensuracaoPendenteTemas",
      ]);
      const mensuracaoUltimaData = this.getPayloadField([
        "mensuracao_ultima_data",
        "mensuracaoUltimaData",
        "MensuracaoUltimaData",
      ]);
      const mensuracaoDetalhes = this.getPayloadField([
        "mensuracao_detalhes",
        "mensuracaoDetalhes",
        "MensuracaoDetalhes",
      ]);

      const municipioComparison = this.metaComparison(ianMunicipio, metaUf);
      const regionalComparison = this.metaComparison(ianRegional, metaUf);
      const ufComparison = this.metaComparison(ianUf, metaUf);

      const hasTerritorio =
        territorioEmpreendedorNome &&
        territorioEmpreendedorNome.toString().trim().length > 0;

      const cards = [
        {
          title: "Status",
          icon: "mdi-information",
          display: status,
          valueClass: "",
          helper: null,
          helperClass: "",
          tooltip: null,
          permissionKey: "dadosIanStatus",
        },
        {
          title: "Elegível IAN",
          icon: "mdi-shield-check",
          display: elegivel,
          valueClass: this.elegivelClass(elegivel),
          helper: null,
          helperClass: "",
          tooltip: null,
          permissionKey: "dadosIanElegivel",
        },
        {
          title: "Eixos trabalhados no ciclo",
          icon: "mdi-axis-arrow",
          display: eixosUnicosCiclo,
          valueClass: "",
          helper: null,
          helperClass: "",
          tooltip: eixosUnicosCicloLista,
          permissionKey: "dadosIanEixosTrabalhadosCiclo",
        },
        {
          title: "ADs Ativos",
          icon: "mdi-account-group",
          display: this.formatCountDisplay(adsAtivosQtd),
          valueClass: "",
          helper: null,
          helperClass: "",
          tooltip: adsAtivosNomes,
          permissionKey: "dadosIanAdsAtivos",
        },
        {
          title: "Salas do Empreendedor ativas",
          icon: "mdi-storefront",
          display: salasEmpreendedorQtd ? salasEmpreendedorQtd.toString() : "-",
          valueClass: "",
          helper: null,
          helperClass: "",
          tooltip: salasEmpreendedorDetalhes,
          permissionKey: "dadosIanSalasEmpreendedorAtivas",
        },
        {
          title: "Território Empreendedor ativo",
          icon: "mdi-map",
          display: hasTerritorio
            ? territorioEmpreendedorNomes || territorioEmpreendedorNome
            : "-",
          valueClass: "",
          helper: null,
          helperClass: "",
          tooltip: territorioEmpreendedorNomes,
          permissionKey: "dadosIanTerritorioEmpreendedorAtivo",
        },
        {
          title: "Iniciativas do Território Empreendedor",
          icon: "mdi-lightbulb-on",
          display: hasTerritorio
            ? this.formatCountDisplay(iniciativasTerritorioQtd, "0")
            : "-",
          valueClass: "",
          helper: null,
          helperClass: "",
          tooltip: hasTerritorio ? iniciativasTerritorioDetalhes : null,
          permissionKey: "dadosIanIniciativasTerritorioEmpreendedor",
        },
        {
          title: "IAN do Município",
          icon: "mdi-office-building-marker",
          display: this.formatIanDisplay(ianMunicipio),
          valueClass: municipioComparison.valueClass,
          helper: null,
          helperClass: "",
          tooltip: null,
          permissionKey: "dadosIanIanMunicipio",
        },
        {
          title: "IAN da Regional",
          icon: "mdi-map-marker-radius",
          display: this.formatIanDisplay(ianRegional),
          valueClass: regionalComparison.valueClass,
          helper: null,
          helperClass: "",
          tooltip: null,
          permissionKey: "dadosIanIanRegional",
        },
        {
          title: "IAN da UF / Meta",
          icon: "mdi-flag",
          display: this.formatIanMetaDisplay(ianUf, metaUf),
          valueClass: ufComparison.valueClass,
          helper: null,
          helperClass: "",
          tooltip: null,
          permissionKey: "dadosIanIanUfMeta",
          action: "ianMemoriaCalculo",
        },
        {
          title: "Mensuração",
          icon: "mdi-clipboard-text-clock",
          display: mensuracaoPendente
            ? "Mensuração Pendente"
            : mensuracaoUltimaData
            ? `Última Mensuração: ${mensuracaoUltimaData}`
            : "-",
          valueClass: mensuracaoPendente
            ? "meta-below"
            : mensuracaoUltimaData
            ? "meta-above"
            : "",
          helper: null,
          helperClass: "",
          tooltip: mensuracaoPendente
            ? mensuracaoPendenteTemas
            : mensuracaoDetalhes,
          permissionKey: "dadosIanMensuracao",
        },
      ];

      return cards.filter((card) =>
        this.canShowDadosIanCard(card.permissionKey)
      );
    },
    shouldShowDadosIanCards() {
      return this.dadosIanCards.length > 0;
    },
    ianMemoriaResumo() {
      return this.ianMemoriaRows.length > 0 ? this.ianMemoriaRows[0] : null;
    },
    consolidadoCards() {
      const metaUf = this.getPayloadNumber(
        ["meta_uf", "metaUF", "MetaUF"],
        true
      );
      const ianMunicipio = this.getPayloadNumber(
        ["ian_municipio", "IAN_Municipio", "ianMunicipio"],
        true
      );
      const ianRegional = this.getPayloadNumber(
        ["ian_regional", "IAN_Regional", "ianRegional"],
        true
      );
      const ianUf = this.getPayloadNumber(["ian_uf", "IAN_UF", "ianUF"], true);
      const status =
        this.getPayloadField([
          "status_consolidado",
          "statusMunicipio",
          "status_nome",
          "status",
        ]) || "-";
      const elegivel = this.formatElegivel(
        this.getPayloadField([
          "elegivelIan",
          "ElegivelIan",
          "elegivel_ian",
          "Elegível IAN",
        ])
      );

      const municipioComparison = this.metaComparison(ianMunicipio, metaUf);
      const regionalComparison = this.metaComparison(ianRegional, metaUf);
      const ufComparison = this.metaComparison(ianUf, metaUf);

      const cards = [
        {
          title: "Pontos Totais",
          icon: "mdi-star-circle",
          display: this.formatPointsDisplay(
            this.getPayloadNumber(
              ["pontos_especificos", "pontosEspecificos", "pontos"],
              false
            )
          ),
          valueClass: "metric-highlight",
          helper: null,
          helperClass: "",
        },
        {
          title: "Status",
          icon: "mdi-information",
          display: status,
          valueClass: "",
          helper: null,
          helperClass: "",
        },
        {
          title: "Elegível IAN",
          icon: "mdi-shield-check",
          display: elegivel,
          valueClass: this.elegivelClass(elegivel),
          helper: null,
          helperClass: "",
        },
        {
          title: "IAN do Município",
          icon: "mdi-office-building-marker",
          display: this.formatIanDisplay(ianMunicipio),
          valueClass: municipioComparison.valueClass,
          helper: municipioComparison.helper,
          helperClass: municipioComparison.helperClass,
        },
        {
          title: "IAN da Regional",
          icon: "mdi-map-marker-radius",
          display: this.formatIanDisplay(ianRegional),
          valueClass: regionalComparison.valueClass,
          helper: regionalComparison.helper,
          helperClass: regionalComparison.helperClass,
        },
        {
          title: "IAN da UF",
          icon: "mdi-flag",
          display: this.formatIanDisplay(ianUf),
          valueClass: ufComparison.valueClass,
          helper: ufComparison.helper,
          helperClass: ufComparison.helperClass,
        },
      ];

      return cards;
    },
    ianAtualizadoEmDisplay() {
      const atualizadoEm = this.getPayloadField([
        "ian_atualizado_em",
        "ianAtualizadoEm",
        "ian_atualizadoEm",
      ]);
      return this.formatIanAtualizadoEm(atualizadoEm);
    },
  },
};
</script>

<style lang="scss" scoped>
.consolidado-bar {
  margin: 24px 0;
}

.dados-ian-bar {
  margin: 16px 0 24px;
}

.consolidado-updated {
  margin-top: 12px;
  font-size: 0.9rem;
  color: #6b7280;
}

.metric-row {
  gap: 16px 0;
  margin: 0 -8px;
}

.metric-col {
  padding: 0 8px;
}

.metric-card {
  position: relative;
  height: 120px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }

  &--default {
    .metric-card__background {
      background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
      border-left: 4px solid #64748b;
    }
  }

  &--primary {
    .metric-card__background {
      background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
      border-left: 4px solid #3b82f6;
    }
  }

  &--success {
    .metric-card__background {
      background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
      border-left: 4px solid #10b981;
    }
  }

  &--error {
    .metric-card__background {
      background: linear-gradient(135deg, #fef2f2 0%, #fecaca 100%);
      border-left: 4px solid #ef4444;
    }
  }
}

.metric-card__background {
  height: 100%;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
}

.metric-card__icon-wrapper {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.metric-card__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.metric-card__title {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.2;
}

.metric-card__value {
  font-size: 20px;
  font-weight: 800;
  color: #1e293b;
  line-height: 1.1;
  margin: 2px 0;
}

.metric-card__helper {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
  opacity: 0.8;
}

.metric-card__indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;

  &.indicator--primary {
    background: linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%);
  }

  &.indicator--success {
    background: linear-gradient(90deg, #10b981 0%, #059669 100%);
  }

  &.indicator--error {
    background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%);
  }

  &.indicator--default {
    background: linear-gradient(90deg, #64748b 0%, #475569 100%);
  }
}

.metric-highlight {
  color: #3b82f6 !important;
  text-shadow: 0 1px 2px rgba(59, 130, 246, 0.1);
}

.meta-above {
  color: #10b981 !important;
  text-shadow: 0 1px 2px rgba(16, 185, 129, 0.1);
}

.meta-below {
  color: #ef4444 !important;
  text-shadow: 0 1px 2px rgba(239, 68, 68, 0.1);
}

.ian-memory-dialog__title {
  align-items: flex-start;
  gap: 12px;
}

.ian-memory-dialog__heading {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.ian-memory-dialog__summary {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  line-height: 1.4;
}

.ian-memory-table {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

// Responsividade
@media (max-width: 960px) {
  .metric-card {
    height: 100px;

    .metric-card__background {
      padding: 12px;
      gap: 10px;
    }

    .metric-card__icon-wrapper {
      width: 40px;
      height: 40px;
    }

    .metric-card__title {
      font-size: 11px;
    }

    .metric-card__value {
      font-size: 18px;
    }

    .metric-card__helper {
      font-size: 10px;
    }
  }
}

@media (max-width: 600px) {
  .consolidado-bar {
    margin: 16px 0;
  }

  .metric-row {
    gap: 12px 0;
    margin: 0 -6px;
  }

  .metric-col {
    padding: 0 6px;
  }

  .metric-card {
    height: 90px;
    border-radius: 12px;

    .metric-card__background {
      padding: 10px;
      gap: 8px;
    }

    .metric-card__icon-wrapper {
      width: 36px;
      height: 36px;
      border-radius: 10px;
    }

    .metric-card__title {
      font-size: 10px;
    }

    .metric-card__value {
      font-size: 16px;
    }

    .metric-card__helper {
      font-size: 9px;
    }
  }
}

.chart-row {
  margin-top: 24px;
  margin-bottom: 16px;
  width: 100% !important;

  .v-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 1 1 100% !important;
  }
}

.chart-header {
  margin-bottom: 20px;

  .chart-title {
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 4px;
  }

  .chart-subtitle {
    font-size: 14px;
    color: #64748b;
    margin-bottom: 16px;
    font-style: italic;
  }

  .chart-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 8px;
    }

    .legend-item {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      color: #475569;

      .legend-color {
        width: 12px;
        height: 12px;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.1);

        &.legend-excellent {
          background-color: rgba(16, 185, 129, 0.8);
        }

        &.legend-good {
          background-color: rgba(245, 158, 11, 0.8);
        }

        &.legend-regular {
          background-color: rgba(249, 115, 22, 0.8);
        }

        &.legend-needs-improvement {
          background-color: rgba(239, 68, 68, 0.8);
        }
      }
    }
  }
}

.bar-chart-wrapper {
  padding: 10px;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  position: relative;
  width: 100% !important;
  display: block;
  min-width: 100%;
  box-sizing: border-box;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #3b82f6 0%, #1d4ed8 50%, #7c3aed 100%);
    border-radius: 12px 12px 0 0;
  }

  .custom-bar-chart {
    width: 100%;
    max-height: 500px;
    overflow-y: auto;
    padding-right: 8px;

    // Scrollbar estilizada
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f5f9;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 4px;

      &:hover {
        background: #94a3b8;
      }
    }

    .bar-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 12px;
      min-height: 40px;

      .bar-label {
        width: 35%;
        font-size: 14px;
        font-family: "Inter", sans-serif;
        color: #475569;
        padding-right: 16px;
        text-align: right;
        word-wrap: break-word;
      }

      .bar-group {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .bar-container {
        height: 24px;
        background: #f1f5f9;
        border-radius: 6px;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;

        .bar-fill {
          height: 100%;
          border-radius: 6px;
          position: relative;
          transition: all 0.8s ease;
          min-width: 4px;
          cursor: pointer;

          &:hover {
            opacity: 0.9;
            transform: scaleY(1.05);
            filter: brightness(1.1);
          }
        }

        .bar-value {
          color: #475569;
          font-size: 12px;
          font-weight: 600;
          font-family: "Inter", sans-serif;
          margin-left: 8px;
          min-width: 40px;
          text-align: left;
        }

        &.bar-container-total .bar-fill-total {
          background: linear-gradient(90deg, #fb923c 0%, #f97316 100%);
        }

        &.bar-container-validated .bar-fill-validated {
          background: linear-gradient(90deg, #60a5fa 0%, #2563eb 100%);
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 16px 12px 12px 60px;
    border-radius: 8px;
  }

  // Scroll condicional apenas quando necessário
  &.has-many-items {
    overflow-y: auto;

    // Scrollbar estilizada
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f5f9;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 4px;

      &:hover {
        background: #94a3b8;
      }
    }

    &::before {
      position: sticky;
      top: 0;
      z-index: 1;
    }
  }
}

.no-data {
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  font-style: italic;
  font-size: 16px;
}

// Estilos para o Banner Unificado
.banner-unificado {
  .banner-title {
    color: #ff6f00;
    font-weight: 600;
    font-size: 24px;
    display: flex;
    align-items: center;
  }

  .info-section {
    .info-item {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 1.5;
      margin-bottom: 8px;

      .v-icon {
        align-self: flex-start;
        margin-top: 1px;
      }

      span {
        flex: 1;
      }
    }
  }

  .campos-edicao {
    .campo-item {
      .campo-header {
        display: flex;
        align-items: flex-start;

        .campo-number {
          flex-shrink: 0;
        }

        .campo-text {
          flex: 1;
          font-size: 14px;
          line-height: 1.4;
          color: #2c3e50;
        }
      }
    }
  }

  .acoes-section {
    .v-btn {
      text-transform: none !important;
      font-weight: 600;
    }
  }
}

.chamada-banner {
  h3 {
    color: #ff6f00;
    font-weight: 600;
  }

  div {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 1.4;
  }
}

.canais-digitais-container {
  margin-bottom: 24px;

  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    .title {
      font-size: 28px;
      font-weight: 600;
      color: #2c3e50;
      margin: 0;
    }

    .edit-btn {
      text-transform: none !important;
      border-radius: 8px !important;
      font-weight: 500;
    }
  }

  .content-card {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
    border-radius: 16px !important;
  }

  .campo-section {
    border-left: 4px solid #1976d2 !important;
    margin-bottom: 16px;

    .campo-header {
      display: flex;
      align-items: flex-start;
      gap: 16px;

      .campo-number {
        flex-shrink: 0;
      }

      .campo-text {
        flex: 1;
        line-height: 1.6;
        color: #2c3e50;
        font-size: 15px;
      }
    }

    .input-section {
      .help-text {
        font-size: 13px;
        line-height: 1.5;
        margin: 0;
      }
    }
  }
}

.perguntas-edicao-container {
  margin-bottom: 20px;
  border-radius: 16px !important;
  overflow: hidden;
  border: 1px solid #e0e7ff !important;
  box-shadow: 0 4px 20px rgba(37, 99, 235, 0.08) !important;
}

.pe-header {
  background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 60%, #3b82f6 100%);
  padding: 20px 20px 16px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  &__badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: rgba(255, 255, 255, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 20px;
    padding: 3px 10px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #fff;
    margin-bottom: 8px;
  }

  &__title {
    font-size: 20px;
    font-weight: 800;
    color: #fff;
    margin: 0 0 6px;
    line-height: 1.2;
  }

  &__subtitle {
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.82);
    margin: 0;
    line-height: 1.5;

    strong {
      color: #fde68a;
    }
  }
}

.pe-timer {
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  padding: 10px 14px;
  min-width: 190px;
  flex-shrink: 0;
  border: 1px solid transparent;

  &__icon {
    flex-shrink: 0;
  }

  &__label {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    opacity: 0.75;
    margin-bottom: 2px;
  }

  &__value {
    font-size: 17px;
    font-weight: 800;
    line-height: 1.15;
    font-variant-numeric: tabular-nums;
  }

  &--active {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.25);

    .pe-timer__label,
    .pe-timer__value {
      color: #fff;
    }
  }

  &--expired {
    background: rgba(239, 68, 68, 0.15);
    border-color: rgba(239, 68, 68, 0.35);

    .pe-timer__label,
    .pe-timer__value {
      color: #fecaca;
    }
  }
}

.pe-body {
  padding: 20px 20px 16px !important;
}

.pe-pergunta {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  margin-bottom: 20px;

  &__numero {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
    color: #fff;
    font-size: 13px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1px;
    box-shadow: 0 2px 6px rgba(37, 99, 235, 0.35);
  }

  &__conteudo {
    flex: 1;
  }

  &__texto {
    font-size: 13.5px;
    color: #374151;
    line-height: 1.5;
    margin: 0 0 8px;
    font-weight: 500;
  }
}

.perguntas-edicao-acoes {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;

  .v-btn {
    text-transform: none !important;
    font-weight: 700;
    border-radius: 10px !important;
  }
}

.tituloStatus {
  font-size: 40px;
  font-weight: bold;
}
.diagnosticoSelo {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  /* padding: 3rem; */
  height: 100%;
  row-gap: 3rem;
}
</style>

<style lang="scss">
.container {
  height: 100%;
}
.htmlContainer {
  padding: 0 2rem !important;
  text-align: justify !important;
}
.estruturas {
  text-align: left !important;

  width: fit-content;
  row-gap: 10px;
  display: flex;
  flex-direction: column;
}

.tamanho {
  max-width: 1300px;
}

.atencao {
  text-align: center;
}
</style>
